'use client';

import Link from 'next/link';
import { useActionState } from 'react';
import { cadastrar } from '@/lib/acoes-acesso';
import { Entrada, Rotulo, Ajuda } from '@/components/ui/Campo';
import { BotaoEnviar, Alerta } from '@/components/ui/Formulario';

export default function PaginaCadastrar() {
  const [estado, acao] = useActionState(cadastrar, undefined);

  return (
    <div className="w-full max-w-sm rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
      <h1 className="text-xl font-bold text-gray-900">Criar conta</h1>
      <p className="mt-1 text-sm text-gray-500">
        Sua conta passa por aprovação antes de liberar o painel.
      </p>

      <form action={acao} className="mt-6 space-y-4">
        <Alerta mensagem={estado?.erro} />
        <div>
          <Rotulo htmlFor="nome">Nome</Rotulo>
          <Entrada id="nome" name="nome" autoComplete="name" required />
        </div>
        <div>
          <Rotulo htmlFor="email">E-mail</Rotulo>
          <Entrada id="email" name="email" type="email" autoComplete="email" required />
        </div>
        <div>
          <Rotulo htmlFor="senha">Senha</Rotulo>
          <Entrada id="senha" name="senha" type="password" autoComplete="new-password" required minLength={8} />
          <Ajuda>Mínimo de 8 caracteres.</Ajuda>
        </div>
        <BotaoEnviar carregando="Criando...">Criar conta</BotaoEnviar>
      </form>

      <p className="mt-5 text-center text-sm text-gray-500">
        Já tem conta?{' '}
        <Link href="/entrar" className="font-medium text-indigo-600 hover:underline">
          Entrar
        </Link>
      </p>
    </div>
  );
}
